/*
 * ******************************************************************
 * Copyright (c) 2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { APP_ROUTES_UTIL } from "@app/app-routing.util";

export class QUORUM_CONSOLE {
    public static readonly EMPTY = "";
    public static readonly ROOT = "approval";
    public static readonly ROOT_ABSOLUTE = APP_ROUTES_UTIL.absolutePath(this.EMPTY, this.ROOT);
    public static readonly APPROVALS = "approvals";
    public static readonly APPROVALS_ABSOLUTE = this.ROOT_ABSOLUTE + this.APPROVALS;
    public static readonly CREATE_APPROVAL_KEY = "create-approval-key";
    public static readonly CREATE_APPROVAL_KEY_ABSOLUTE = this.ROOT_ABSOLUTE + this.CREATE_APPROVAL_KEY;
    public static readonly ERROR_403 = "error";
    public static readonly ERROR_403_ABSOLUTE = this.ROOT_ABSOLUTE + this.ERROR_403;
    public static readonly CAPABILITIES_ERROR = "error-props";
    public static readonly CAPABILITIES_ERROR_ABSOLUTE = this.ROOT_ABSOLUTE + this.CAPABILITIES_ERROR;
}
